import React from "react";

import FeaturedComponent from './components/Featured';
import Navbarone from './components/Navbar';
import HeroComponent from './components/Hero.js';

import Signup from './components/signUp';
import Footerdown from './components/Footer'

function App() {
  return (

    <div>
      <Navbarone />,
      <HeroComponent/>,
      <FeaturedComponent/>,
      <Signup/> ,
      <Footerdown/>,
      </div>
  );
}

export default App;
